module.exports = __webpack_public_path__ + "static/media/index1.157197fa.png";